import { useEffect, useRef, useState } from "react";
import { Button, Spinner } from "reactstrap";

interface RefreshButtonProps {
  spinning: boolean;
  onRefresh: () => void;
}

const minimumSpinMs = 1000;

const RefreshButton = (props: RefreshButtonProps) => {
  const [minElapsed, setMinElapsed] = useState(true);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (!props.spinning) return;
    setMinElapsed(false);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setMinElapsed(true), minimumSpinMs);
  }, [props.spinning]);

  useEffect(() => () => clearTimeout(timer.current), []);

  const visibleSpin = props.spinning || !minElapsed;

  return <Button className="py-0"
    color="link"
    aria-label="Refresh"
    disabled={visibleSpin}
    onClick={props.onRefresh}>
    <span className="icon align-middle">
      {visibleSpin
        ? <Spinner />
        : <i className="bi-arrow-clockwise fs-2 lh-1" />}
    </span>
  </Button>
}

export default RefreshButton;
